import React, { useEffect, useState } from 'react';
import { useParams, Redirect } from 'react-router-dom';
import { toast } from 'react-toastify';
import GlobalLoading from 'v2/components/Shared/GlobalLoading';
import useGetUser from 'v2/hooks/useGetUser';
import { customerFactory } from 'v2/services/customer';

const InviteNewUser = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const { producerId } = useParams<{ producerId: string }>();
  const user = useGetUser();

  useEffect(() => {
    if (producerId && user) customerFactory.setReferred(user.id, producerId).subscribe(() => setIsLoading(false), toast.error);
  }, [producerId, user]);

  if (isLoading) return <GlobalLoading />;

  return <Redirect to='/' />;
};

export default InviteNewUser;
